module.exports = __webpack_public_path__ + "img/search_diagnostic.8298983c.svg";